import { Settings, Sliders, UserPlus, Users, ChevronsUp, DollarSign,
  //  BarChart2,
    MapPin, Grid, Target, FileText } from 'react-feather';

const pagesSection = [
  {
    href: '/admin/dashboard',
    title: 'Dashboard',
    icon: Sliders,
    children: [
      {
        href: '/admin/dashboard/default',
        title: 'Default',
      },
      {
        href: '/admin/dashboard/sales',
        title: 'Sälj',
      },
      {
        href: '/admin/dashboard/ranking',
        title: 'Ranking',
      },
      {
        href: '/admin/dashboard/user-statistics',
        title: 'User statistics',
      },
      {
        href: '/admin/dashboard/leads',
        title: 'Leads',
      },
    ],
  },
  // Temporarily hidden until backend team completes their update
  // {
  //   href: 'statistik',
  //   title: 'Statistik',
  //   icon: BarChart2,
  //   children: [
  //     {
  //       href: '/admin/statistik/landningsida',
  //       title: 'Landningsida',
  //     },
  //     {
  //       href: '/admin/statistik/hemsida',
  //       title: 'Hemsida',
  //     },
  //   ],
  // },
  {
    href: 'produkter',
    title: 'Produkter',
    icon: Grid,
    children: [
      {
        href: '/admin/sites',
        title: 'Landningssidor',
      },
      {
        href: '/admin/hemsidor',
        title: 'Hemsidor',
      },
    ],
  },
  {
    href: 'client',
    title: 'Inlogg kunder',
    icon: Users,
  },
  {
    href: 'kundföretag',
    title: 'Kundföretag',
    icon: Users,
  },
  {
    href: 'our-leads',
    title: 'Våra leads',
    icon: Target,
  },
  {
    href: 'leads',
    title: 'Kundförfrågningar',
    icon: UserPlus,
  },
  {
    href: 'utm-overview',
    title: 'UTM Spårning',
    icon: Target,
  },
  {
    href: 'settings',
    title: 'Inställningar',
    icon: Settings,
  },
  {
    href: 'users',
    title: 'Användare',
    icon: Users,
  },
  {
    href: 'optimering',
    title: 'Optimering',
    icon: Users,
    children: [
      {
        href: '/admin/optimering/all',
        title: 'Pending',
      },
      {
        href: '/admin/optimering/beställning',
        title: 'Beställning',
      },
      {
        href: '/admin/optimering/production',
        title: 'Production',
      },
      {
        href: '/admin/optimering/live',
        title: 'Live',
      },
      {
        href: '/admin/optimering/lost',
        title: 'Lost',
      },
    ],
  },
  {
    href: 'proposal',
    title: 'Proposals',
    icon: ChevronsUp,
  },
  {
    href: 'invoices',
    title: 'Fakturor',
    icon: DollarSign,
  },
  {
    href: 'dpa',
    title: 'DPA Avtal',
    icon: FileText,
  },
  {
    href: 'data-management',
    title: 'Data Hantering',
    icon: MapPin,
    children: [
      {
        href: '/admin/data-management/cities',
        title: 'Städer',
      },
      {
        href: '/admin/data-management/blocklist',
        title: 'Blocklista',
      },
    ],
  },
];

const navItems = [
  {
    title: '',
    pages: pagesSection,
  },
];

export default navItems;
